//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "marionette",
  "./template/taskUploadItemTemplate.html",
  "./template/taskUploadsTemplate.html",
], function (Marionette, TaskUploadItemTemplate, TaskUploadsTemplate) {
  "use strict";

  var TaskUploadsView = {};

  TaskUploadsView.taskUploadItemView = Marionette.ItemView.extend({
    template: TaskUploadItemTemplate,
    tagName: "<tr>",
    textboxes: function () {
      if (this.model.collection.allowUpdate) {
        return {
          "#taskUploadDescription": {
            enableSelector: ["#taskUploadDescription"],
            modelAttribute: "description",
            placeholder: "task.uploads.description",
          },
        };
      }
    },
    triggers: {
      "click .task-upload-delete": "delete:upload",
    },
  });

  TaskUploadsView.taskUploadsView = Marionette.CompositeView.extend({
    template: TaskUploadsTemplate,
    itemView: TaskUploadsView.taskUploadItemView,
    itemViewContainer: "tbody",
    events: {
      "change #addUpload": function (e) {
        var file = e.target.files[0];
        this.trigger("add:upload", file, e.target.form);
      },
    },
  });

  return TaskUploadsView;
});
